import React from 'react';
import NotFoundPage from '../../../pages/NotFound/NotFound';

export default ({ location }) => {
  return <NotFoundPage location={location} />;
};
